import React, { useMemo, useState } from "react";
import { GET_DENIAL_REASONS_LIST } from "./services/get-denial-reasons-list";
import { useDispatch, useSelector } from "react-redux";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../../common_components/common_widgets/data-grid";
import { getDataGridActionEllipsisComponent } from "../../../common_components/common_widgets/data-grid-action-ellipsis";
import {
  defaultDenialReasonsFormData,
  RESET_DENIAL_REASONS_POPUP_VALIDATION,
  SET_DENIAL_REASONS_DATAGRID_FILTER,
  SET_DENIAL_REASONS_FORM_DATA,
  TOGGLE_ADD_DENIAL_REASONS_POPUP,
  TOGGLE_DENIAL_REASONS_LIST_ACTION_POPOVER,
  TOGGLE_DENIAL_REASONS_WARNING_POPUP,
} from "../denial-reasons/reducers/denial-reasons-reducer";
import { actions, callOperation } from "async-ops";
import MdaeActionPopover from "../../../common_components/common_widgets/menu-action-popover";
import "./index.scss";
import AddDenialReasonsPopup, {
  openDenialReasonsInEditMode,
} from "./denial-reason-pop-up";
import { cloneDeep, first, isEqual } from "lodash";
import { getUserPermissionObject } from "../../../common_components/user-permissions-helper";
import MdaeAddButton from "../../../common_components/common_widgets/add-button";
import { COPY_DENIAL_REASONS } from "./services/copy-denial-reasons";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../../common_components/common_widgets/toast/notify";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_CONFIRMATION_POPUP,
} from "../../../common_components/mdae-common-reducer";
import { GET_DENIAL_REASONS_LINKED_DATA } from "./services/get-denial-reasons-linked-data";
import { DELETE_DENIAL_REASONS } from "./services/delete-denial-reasons";
import { format } from "date-fns";

export const DENIAL_REASONS_POPUP_MODE = {
  ADD: "ADD",
  EDIT: "EDIT",
};
export const DENIAL_REASONS_WARNING_POPUP_MODE = {
  CHANGES_ON_EXISTING_DENIAL_REASON_WARNING:
    "CHANGES_ON_EXISTING_DENIAL_REASON_WARNING",
  CHNAGES_ON_DENIAL_REASONS_LINKED_TO_AUDIT_WARNING:
    "CHNAGES_ON_DENIAL_REASONS_LINKED_TO_AUDIT_WARNING",
  CANNOT_CHANGE_AUDIT_GROUPS_FOR_DENIAL_REASON_LINKED_TO_AUDIT_WARNING:
    "CANNOT_CHANGE_AUDIT_GROUPS_FOR_DENIAL_REASON_LINKED_TO_AUDIT_WARNING",
    DELETE_DENIAL_REASONS_LINKED_TO_AUDIT_WARNING:
    "DELETE_DENIAL_REASONS_LINKED_TO_AUDIT_WARNING",
    TERM_DATE_WARNING:"TERM_DATE_WARNING"
};
const deleteDenialReasontemplateMessage =
  "Deleting this Denial reason cannot be undone. Do you want to continue?";

export const deleteDenialReasons = (denialReasonsData, dispatch) => {
  return new Promise<void>((resolve, reject) => {
    dispatch({ type: SHOW_LOADER });
    callOperation(DELETE_DENIAL_REASONS, denialReasonsData)
      .then(function(response) {
        if (response.isSaved) {
          dispatch(actions.asyncOperationStart(GET_DENIAL_REASONS_LIST, {}));
          resolve();
        }
      })
      .finally(() => {
        dispatch({ type: HIDE_LOADER });
      });
  });
};

export const toggleDenialReasonsPopup = (dispatch,
  isVisible,
  title = "Create New Denial Reason",
  mode = DENIAL_REASONS_POPUP_MODE.ADD
) => {
  dispatch({
    type: TOGGLE_ADD_DENIAL_REASONS_POPUP,
    data: {
      denialReasonsPopupMode: mode,
      denialReasonsPopupTitle: title,
      isAddDenialReasonsPopupVisible: isVisible,
      denialReasonsFormData:cloneDeep(defaultDenialReasonsFormData)
    },    
  });
  dispatch({
    type: RESET_DENIAL_REASONS_POPUP_VALIDATION,
    data: {      
      isDenialReasonsFormDataValid:true
    },    
  });
  if(!isVisible){
    dispatch({
      type: SET_DENIAL_REASONS_FORM_DATA,
      data: {
        denialReasonsFormData: {
          moduleTypeValue: null,
        },
      },
    }); 
  }   
};



const DenialReasons: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const denialReasonsPopupMode = useSelector(
    (state: any) => state.denialReasons.denialReasonsPopupMode,
    isEqual
  );
  const currentUser = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.currentUser,
    isEqual
  );
  const denialReasonsPermissions = getUserPermissionObject(
    "DENIAL_REASONS",
    currentUser
  );
  const currentUrlSearchParams = new URLSearchParams(
    window.location.href.split("?")[1]
  );
  const [denialReasonsDataGridInstance, setDenialReasonsDataGridInstance] = useState(null);
  const getCurrentSelectedRowData: any = () => {
    return first(denialReasonsDataGridInstance?.getSelectedRowsData());
  };
  for (let parameterPair of currentUrlSearchParams.entries() as any) {
    if (parameterPair[0] && parameterPair[0].toLowerCase() === "categoryid") {
      const categoryId = parseInt(parameterPair[1]);
      if (!isNaN(categoryId) && categoryId > 0) {
        dispatch({
          type: SET_DENIAL_REASONS_DATAGRID_FILTER,
          data: {
            denialReasonsDataGridFilter: ["categoryId", "=", categoryId],
          },
        });
      }
    }
  }
 
  const toggleDenialReasonsListActionPopover = (isVisible, target) => {
    dispatch({
      type: TOGGLE_DENIAL_REASONS_LIST_ACTION_POPOVER,
      data: {
        denialReasonsListDataGridActionPopoverTarget: target,
        isDenialReasonsListDataGridActionPopoverVisible: isVisible,
      },
    });
  };

  const hideConfirmationPopup = () => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        visible: false,
      },
    });
  };
  const showConfirmationPopup = (message) => {
    toggleDenialReasonsListActionPopover(false, null);
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: () => {
          toggleDenialReasonsListActionPopover(false, null);
          deleteDenialReasons(getCurrentSelectedRowData(), dispatch).then(() => {
            hideConfirmationPopup();
          });
        },
        visible: true,
        confirmShown: true,
        declineShown: true,
        width: 380,
        height: 200,
        contentHtml: message,
        onDecline: hideConfirmationPopup,
      },
    });
  };
  const toggleConfirmationPopupVisible = (isVisible, message) => {
    if (isVisible) {
      showConfirmationPopup(message);
    } else {
      hideConfirmationPopup();
    }
  };
  const toggleDenialReasonsWarningPopupVisible = (isVisible, popupMode) => {
    dispatch({
      type: TOGGLE_DENIAL_REASONS_WARNING_POPUP,
      data: {
        isDenialReasonsWarningPopupVisible: isVisible,
        denialReasonsWarningPopupMode: popupMode,
      },
    });
  };
  const denialReasonsListActionPopoverMenuList = () => [
    {
      text: denialReasonsPermissions.hasUpdateAccess ? "Edit" : "Preview",
      icon: () => {
        return (
          <div
            style={{ height: "14px" }}
            className={
              denialReasonsPermissions.hasUpdateAccess
                ? "edit-action-icon"
                : "preview-action-icon"
            }
          ></div>
        );
      },
      onClick: () => {
        toggleDenialReasonsListActionPopover(false, null);
        openDenialReasonsInEditMode(
          getCurrentSelectedRowData(),
          toggleDenialReasonsPopup,
          dispatch
        );
      },
    },
    {
      text: "Copy",
      icon: () => {
        return (
          <div style={{ height: "16px" }} className={"copy-action-icon"}></div>
        );
      },
      visible: false,
      onClick: () => {
        toggleDenialReasonsListActionPopover(false, null);
        copyDenialReasons(getCurrentSelectedRowData(), dispatch);
      },
    },
    {
      text: "Delete",
      visible: false,
      icon: () => {
        return (
          <div
            style={{ height: "16px" }}
            className={"delete-action-icon"}
          ></div>
        );
      },      
      onClick: () => {
        const currentSelectedRowData = getCurrentSelectedRowData();
        if (!currentSelectedRowData.curatedInd) {
          dispatch({ type: SHOW_LOADER });
          callOperation(
            GET_DENIAL_REASONS_LINKED_DATA,
            currentSelectedRowData.denialReasonId
          )
            .then(function(response) {
              if (
                response.denialReasonAttachedAudit &&
                response.denialReasonAttachedAudit.length > 0
              ) {
                dispatch({
                  type: SET_DENIAL_REASONS_FORM_DATA,
                  data: {
                    denialReasonsFormData: cloneDeep(currentSelectedRowData),
                  },
                });
                toggleDenialReasonsListActionPopover(false, null);
                toggleDenialReasonsWarningPopupVisible(
                  true,
                  DENIAL_REASONS_WARNING_POPUP_MODE.DELETE_DENIAL_REASONS_LINKED_TO_AUDIT_WARNING
                );
              } else toggleConfirmationPopupVisible(true, deleteDenialReasontemplateMessage);
            })
            .finally(() => {
              dispatch({ type: HIDE_LOADER });
            });
        }
      },
    },
  ];

  const denialReasonsListDataGridOptions = useMemo(() => {
    return getDenialReasonsListDataGridOptions(
      toggleDenialReasonsListActionPopover,
      dispatch,
      setDenialReasonsDataGridInstance
    );
  }, []);

  const resetDenialReasonsPopupValidation = () => {
    dispatch({
      type: RESET_DENIAL_REASONS_POPUP_VALIDATION,
      data: {
        isDenialReasonsFormDataValid: true,
      },
    });
  };

  const renderToolbarButtonTemplate = () => {
    return (
      <MdaeAddButton
        id={"btnAddNewDenialReasons"}
        title={"Create New Denial Reason"}
        visible={true}
        onClick={() => {
          dispatch({
            type: SET_DENIAL_REASONS_FORM_DATA,
            data: {
              denialReasonsFormData: cloneDeep(defaultDenialReasonsFormData),
              initialDenialReasonsFormData: cloneDeep(
                defaultDenialReasonsFormData
              ),
            },
          });
          resetDenialReasonsPopupValidation();
          toggleDenialReasonsPopup(dispatch,true);
        }}
      ></MdaeAddButton>
    );
  };
  return (
    <div className={"page-container-padding"}>
      <MdaeActionPopover
        mdaePopoverConfig={{
          id: "pnlDenialReasonsListActionPopover",
          mdaeDataUpdaterConfig: [
            {
              actionType: TOGGLE_DENIAL_REASONS_LIST_ACTION_POPOVER,
              reducerName: "denialReasons",
              widgetOptionBindings: {
                target: "denialReasonsListDataGridActionPopoverTarget",
                visible: "isDenialReasonsListDataGridActionPopoverVisible",
              },
            },
          ],
        }}
        menuItemListFunction={denialReasonsListActionPopoverMenuList}
      ></MdaeActionPopover>
      <MdaeDataGrid
        {...denialReasonsListDataGridOptions}
        mdaeDataGridCustomButtons={renderToolbarButtonTemplate}
      ></MdaeDataGrid>
      <AddDenialReasonsPopup
      ></AddDenialReasonsPopup>
    </div>
  );
};

const getDenialReasonsListDataGridOptions = (
  toggleActionPopover,
  dispatch,
  setDenialReasonsDataGridInstance
) => {
  const sampleDataGridOption: IMdaeDataGridProps = {
    id: "pnlDenialReasonsList",
    stateStoring: {
      enabled: true,
      type: "localStorage",
      storageKey: "denial-reason-data-grid-storage-key",
    },
    mdaeColumnChooser: { isMdaeColumnChooserVisible: true },
    mdaeSearchPanel: { visible: true },
    clearFilterButtonId: "btn-denial-reason-list-grid-clear-filter",
    export: {
      enabled: true,
      fileName: "DenialReasonss",
    },
    headerFilter: {
      visible: true,
    },
    onRowDblClick: (e) => {
      if(e?.rowType === "data"){
      openDenialReasonsInEditMode(
        e.data,
        toggleDenialReasonsPopup,
        dispatch
      );}
    },
    allowColumnResizing: true,
    allowColumnReordering: true,
    filterRow: {
      visible: true,
    },
    onInitialized(e) {
      setDenialReasonsDataGridInstance(e.component);
    },    
    mdaeColumns: [
      {
        fixed: true,
        alignment: "center",
        cellRender: (e) => {
          return getDataGridActionEllipsisComponent(e, {
            showActionPopover: toggleActionPopover,
            entityName: "denial-reason",
            entityId: e.data.denialReasonId,
            currentRowData: e.data,
            type: "usingDispatch",
            dispatch,
          });
        },
        width: 50,
      },
      {
        caption: "Denial Reason Name",
        dataField: "denialReasonName",
        width: 200,
      },
      {
        caption: " Display Name",
        dataField: "displayName",
        width: 50,
      },
      {
        caption: "Description",
        dataField: "description",
        width: 400,
      },
      {
        caption: "Audit Groups",
        dataField: "auditGroupNames",
        width: 350,
      },
      {
        caption: "Requesters",
        dataField: "organizationName",
        width: 200,
      },
      {
        dataField: "curatedInd",
        dataType: "boolean",
        caption: "Curated",
        allowSearch: false,
        falseText: "NO",
        trueText: "YES",
        width: 80,
      },
      {
        caption: "Effective Date",
        dataField: "effectiveDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
      },
      {
        caption: "Term Date",
        dataField: "termDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
      },
      {
        caption: "Created By",
        dataField: "createdBy",
        width: 120,
      },
      {
        caption: "Created Date",
        dataField: "createDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
      },
      {
        caption: "Updated By",
        dataField: "updatedBy",
        width: 120,
      },
      {
        caption: "Update Date",
        dataField: "updateDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
      },
    ],
    mdaeDataUpdaterConfig: [
      {
        actionType: GET_DENIAL_REASONS_LIST,
        isAsyncComplete: true,
        widgetOptionBindings: {
          dataSource: "denialReasonsList",
        },
      },
      {
        actionType: SET_DENIAL_REASONS_DATAGRID_FILTER,
        reducerName: "denialReasons",
        widgetOptionBindings: {
          filterValue: "denialReasonsDataGridFilter",
        },
      },
    ],
  };
  return sampleDataGridOption;
};

const copyDenialReasons = (currentSelectedRowData, dispatch) => {
  dispatch({ type: SHOW_LOADER });
  callOperation(COPY_DENIAL_REASONS, {
    denialReasonId: currentSelectedRowData.denialReasonId,
  }).then(function(response) {
    dispatch({ type: HIDE_LOADER });
    if (response.isSaved) {
      dispatch(actions.asyncOperationStart(GET_DENIAL_REASONS_LIST, {}));
      mdaeNotify({
        message: response.denialReasonName + " - denial reason saved successfully.",
        messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
      });
    } else {
      mdaeNotify({
        message: "Unable to save denial reason",
        messageType: NOTIFY_MESSAGE_TYPE.ERROR,
      });
    }
  });
};

export default DenialReasons;
